import Styles from '../Text/Text.module.scss'
import cx from 'classnames'
import { factory, Factory } from 'almanac-ui/factory'
import { filterDOMProps } from '@react-aria/utils'
import { TextProps } from 'blaze-ui/Text/Text'
import * as CSS from 'csstype'

export type ParagraphFactory = Factory<{
  props: TextProps
  ref: HTMLParagraphElement
}>

export const Paragraph = factory<ParagraphFactory>(
  ({ variant = 'primary', children, lineClamp, color, ...otherProps }, ref) => {
    const style: CSS.Properties = {
      ['--lines-to-clamp' as any]: lineClamp,
      color: color || undefined,
    }

    return (
      <p
        className={cx(Styles.root, Styles[variant], {
          [Styles.lineClamp]: lineClamp !== 1,
          [Styles.lineClampForceSingleLine]: lineClamp === 1,
        })}
        {...filterDOMProps(otherProps)}
        ref={ref}
        style={style}
      >
        {children}
      </p>
    )
  },
)
